import { CloseIconCircle } from "assets/icons";
import ActionModal from "components/Settings/components/ActionModal";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function FailureModal({ open, setOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCancel = () => {
    navigate(location.pathname, { replace: true });
    setOpen(false);
  };

  return (
    <ActionModal
      title="Your payment has been failed!"
      description="We couldn’t process your payment. Please check your details or try another method."
      open={open}
      setOpen={setOpen}
      footer={{
        right: {
          label: "Try again",
          action: () => {
            handleCancel();
          },
        },
      }}
      icon={<CloseIconCircle />}
      onCancel={handleCancel}
    />
  );
}

export default FailureModal;
